import React, { Component } from 'react';
import { Big3Common, bootstrap } from "../../../js/IncludeManager";
import { Alert } from "../../../js/ComponentManager";
import title from '../../../img/title.svg';

/* 개발담당:양유빈
 * 화면기능:로그인 처리
 * 세부설명:로그인 후 세션스토리지 아이디 값 저장
*/

export class SignIn extends Component {
    static displayName = SignIn.name;

    constructor(props) {
        super(props);
        this.state = {
            LoginModel: {
                Login_Id: "",
                Password: "",
                LoginYuji: false,
                SsoUser: "",
                DeviceID: ""
            },
            MsgTitle:"",
            MsgContent: "",
            isEyeOpen: false,
            isEyeText:"password"
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSignIn = this.handleSignIn.bind(this);
        this.handleEyeClick = this.handleEyeClick.bind(this);
        this.handleMemberInfo = this.handleMemberInfo.bind(this);
        this.handleKakao_Click = this.handleKakao_Click.bind(this);
    }
    //초기화
    componentDidMount() {
        let loginyuji = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.LoginYuji);
        if (loginyuji !== null) {
            //SSO 처리
            Big3Common.updateStateModel({ this: this, modelName: "LoginModel", updateModel: { "LoginYuji": loginyuji} });
            let SsoUser = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Sso_ID);
            if (SsoUser != null) {
                Big3Common.updateStateModel({ this: this, modelName: "LoginModel", updateModel: { "LoginYuji": loginyuji, "SsoUser": SsoUser } });
                this.handleSignIn();
            }
        }
    }
    handleChange(event) {
        let tagId = event.target.id;
        if (tagId === "LoginYuji") {
            let checked = event.target.checked;
            if (checked) {
                Big3Common.WebStorage.SetLocalStorage(Big3Common.WebStorage.StorageName.LoginYuji, checked);
            }
            else {
                Big3Common.WebStorage.RemoveStorage(Big3Common.WebStorage.StorageName.LoginYuji);
                Big3Common.WebStorage.RemoveStorage(Big3Common.WebStorage.StorageName.Sso_ID);
            }
        }
        Big3Common.ValueCahage_StateUpdate({ this: this, event: event, modelName: "LoginModel" });
        return false;
    }
    handleEyeClick(event) {
        if (this.state.isEyeOpen === false) {
            this.setState({ isEyeOpen: true, isEyeText :"text"})
        }
        else {
            this.setState({ isEyeOpen: false, isEyeText: "password" })
        }
    }
    //회원가입 버튼 클릭: 대표/직원 선택
    handleMemberInfo(event,modalId) {

        window.location.href = "/Account/MemberMgr/Index";
        event.preventDefault();
    }
    handleKakao_Click(event) {
        this.setState({ MsgTitle: "카카오톡문의", MsgContent: "카카오톡에서 친구찾기 [@클로디비즈] 로 검색하세요." });
        Big3Common.ModalAlert(bootstrap, "ErrorAlert");
        event.preventDefault();
    }
    //로그인 처리
    async handleSignIn(event) {
        let SsoUser = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Sso_ID);
        let loginyuji = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.LoginYuji);
        if (loginyuji === null) {
            loginyuji = false;
        }

        if (!Boolean(loginyuji) || SsoUser === null) {
            if (this.state.LoginModel.Login_Id.trim().length === 0) {
                this.setState({ MsgTitle: "로그인오류", MsgContent: "아이디를 입력하여 주세요." })
                Big3Common.ModalAlert(bootstrap, 'ErrorAlert');
                return false;
            }
            if (this.state.LoginModel.Password.trim().length === 0) {
                Big3Common.ModalAlert(bootstrap, 'ErrorAlert');
                this.setState({ MsgTitle: "로그인오류", MsgContent: "비밀번호를 입력하여 주세요." })
                return false;
            }    
        }
        
        let jsonValue = this.state.LoginModel;
        const DeviceID = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.SmartPlatformWHDeviceID);
        if (DeviceID !== null && DeviceID !== "") {
            jsonValue.DeviceID = DeviceID;
        }
        let data = await Big3Common.Post("api/Account/LoginMgr/WholeLogin", jsonValue, true);

        if (data.codeName === Big3Common.ResultCode.Error) {
            this.setState({ MsgTitle: "로그인오류", MsgContent: data.message })
            Big3Common.ModalAlert(bootstrap, 'ErrorAlert');
        }
        else if (data.codeName === Big3Common.ResultCode.Warning)
        {
            this.setState({ MsgTitle: "관리자미승인", MsgContent: data.message })
            Big3Common.ModalAlert(bootstrap, 'ErrorAlert');
        }
        else if (data.codeName === Big3Common.ResultCode.Success) {
            
            const Content = data.objectData;
            const uid = Content.ssoUser;
            const org_nm = Content.org_Name;
            const issecondary = Content.issecondary;
            const username = Content.userName;
            const GoodsImageHostName = Content.goods_Image_Hostname;
            const Event_Image_Hostname = Content.event_Image_Hostname;
            const Chat_Identifier = Content.chat_Identifier;

            Big3Common.WebStorage.SetLocalStorage(Big3Common.WebStorage.StorageName.OrgName, org_nm);
            Big3Common.WebStorage.SetLocalStorage(Big3Common.WebStorage.StorageName.IsSecondary, issecondary);
            Big3Common.WebStorage.SetLocalStorage(Big3Common.WebStorage.StorageName.UserName, username);
            Big3Common.WebStorage.SetLocalStorage(Big3Common.WebStorage.StorageName.GoodsImageHostName, GoodsImageHostName);
            Big3Common.WebStorage.SetLocalStorage(Big3Common.WebStorage.StorageName.EventImageHostName, Event_Image_Hostname);
            Big3Common.WebStorage.SetLocalStorage(Big3Common.WebStorage.StorageName.Chat_Identifier, Chat_Identifier);

            if (Boolean(this.state.LoginModel.LoginYuji) === true) {
               
                Big3Common.WebStorage.SetLocalStorage(Big3Common.WebStorage.StorageName.Sso_ID, uid);
            }
            window.location.href = "/";
        }
       
        return false;
    }
    //회원가입 안내 팝업
    
    render() {
        return (
            <form>
                <div className="clodlogo_box">
                    <div className="intro_txt">도매고객용</div>
                    <div className="clodlogo">
                        <img src={title} alt="로고" />
                    </div>
                    <div className="clodtxt">
                        <p>내 폰안에 동대문 사입</p>
                    </div>
                </div>
                <div className="login_box">
                    <div className="login_input_line">
                        <input type="text"
                            id="Login_Id"
                            className="form-control"
                            maxLength="20"
                            placeholder="아이디"
                            onChange={this.handleChange}
                        />
                    </div>
                    {/*<!--비밀번호 안보이기-->*/}
                    <div className="login_input_line">
                        <input type={this.state.isEyeText}
                            id="Password"
                            className="form-control"
                            placeholder="비밀번호"
                            autoComplete="off"
                            onChange={this.handleChange}
                        />
                        <div className={this.state.isEyeOpen === true ? "eye_close" : "eye_open"} onClick={this.handleEyeClick}></div>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input"
                            type="checkbox"
                            id="LoginYuji"
                            onChange={this.handleChange}
                            checked={this.state.LoginModel.LoginYuji}
                        />
                        <label className="form-check-label">
                            로그인 상태 유지
                        </label>
                    </div>
                    <div className="button_line first_line" onClick={this.handleSignIn}>
                        <button type="button" className="btn_v  btn_v1">로그인</button>
                    </div>
                    <div className="button_line first_line">
                        <button type="button" className="btn_v btn_v2" onClick={(e) => this.handleMemberInfo(e,'membership') }>회원가입</button>
                    </div>
                    <div className="login_link">
                        <ul>
                            <li><a href="#!" onClick={(e) => { this.props.RenderComponent('FindID'); e.preventDefault(); }}>아이디 찾기 </a></li>
                            <li><a href="#!" onClick={(e) => { this.props.RenderComponent('FindPwd'); e.preventDefault(); }}>비밀번호 찾기 </a></li>
                            <li><a href="#!" onClick={(e) => { this.handleKakao_Click(e) }}>카톡 문의</a></li>

                        </ul>
                    </div>
                </div>
                <Alert
                    id="ErrorAlert"
                    title={this.state.MsgTitle}
                    content={this.state.MsgContent}
                    zIndex="9999"
                />
                 
            </form>
        );
    }
}
